import { render, staticRenderFns } from "./ActionDecision.vue?vue&type=template&id=839f6974&"
import script from "./ActionDecision.vue?vue&type=script&lang=js&"
export * from "./ActionDecision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports